import { render, staticRenderFns } from "./BadgeTree.vue?vue&type=template&id=3da6b256&scoped=true&"
import script from "./BadgeTree.vue?vue&type=script&lang=js&"
export * from "./BadgeTree.vue?vue&type=script&lang=js&"
import style0 from "./BadgeTree.vue?vue&type=style&index=0&id=3da6b256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da6b256",
  null
  
)

export default component.exports